import { Price } from "./../_models/price";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PriceService } from "./../_services/price.service";
import { Component, Inject, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-edit-price-dialog",
  templateUrl: "./edit-price-dialog.component.html",
  styleUrls: ["./edit-price-dialog.component.scss"],
})
export class EditPriceDialogComponent implements OnInit {
  public isAdd: boolean = false;
  public price: Price;
  constructor(
    private priceService: PriceService,
    public dialogRef: MatDialogRef<EditPriceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) {
    this.isAdd = data.addPrice;
    this.price = new Price();
    this.price.zoneId = data.zoneId;
    this.price.id = data.priceId;
  }

  ngOnInit(): void {
    if (!this.isAdd) {
      this.priceService.getPrice(this.price.id).subscribe((price) => {
        this.price = price;
      });
    }
  }

  isPriceValid() {
    return this.price.weight > 0 && this.price.amount > 0;
  }

  public save(): void {
    if (!this.isPriceValid()) {
      this.showErrorMessage("Weight or amount is required");
      return;
    }

    if (this.isAdd) {
      this.priceService.addPrice(this.price).subscribe((result) => {
        console.log("Price: ", result);
        this.dialogRef.close(result);
      });
    } else {
      this.priceService.updatePrice(this.price).subscribe((result) => {
        console.log("Price: ", result);
        this.dialogRef.close(result);
      });
    }
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }
}
